import { useEffect, useState } from "react";
import { Spin, Tooltip, Input } from "antd";
import "./index.less";
import {
  LeftOutlined,
  RightOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
} from "@ant-design/icons";

import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Pdf = ({ pdfInfo }: { pdfInfo?: RecfindById }) => {
  const [state, setState] = useState({
    pageNumber: 1,
    pageNumberInput: 1,
    pageNumberFocus: false,
    numPages: 1,
    pageWidth: 850,
    fullscreen: false,
  });
  useEffect(() => {
    if (pdfInfo) {
    }
  }, [pdfInfo]);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setState({ ...state, numPages: numPages });
  };

  const lastPage = () => {
    if (state.pageNumber === 1) {
      return;
    }
    const page = state.pageNumber - 1;
    setState({ ...state, pageNumber: page, pageNumberInput: page });
  };
  const nextPage = () => {
    if (state.pageNumber === state.numPages) {
      return;
    }
    const page = state.pageNumber + 1;
    setState({ ...state, pageNumber: page, pageNumberInput: page });
  };
  const onPageNumberFocus = () => {
    setState({ ...state, pageNumberFocus: true });
  };
  const onPageNumberBlur = () => {
    setState({
      ...state,
      pageNumberFocus: false,
      pageNumberInput: state.pageNumber,
    });
  };
  const onPageNumberChange = (e: any) => {
    let value = e.target.value;
    value = value <= 0 ? 1 : value;
    value = value >= state.numPages ? state.numPages : value;
    setState({ ...state, pageNumberInput: value });
  };
  const toPage = (e: any) => {
    setState({ ...state, pageNumber: Number(e.target.value) });
  };

  const pageZoomOut = () => {
    if (state.pageWidth <= 850) {
      return;
    }
    const pageWidth = state.pageWidth * 0.8;
    setState({ ...state, pageWidth: pageWidth });
  };
  const pageZoomIn = () => {
    const pageWidth = state.pageWidth * 1.2;
    setState({ ...state, pageWidth: pageWidth });
  };

  const pageFullscreen = () => {
    if (state.fullscreen) {
      setState({ ...state, fullscreen: false, pageWidth: 850 });
    } else {
      setState({
        ...state,
        fullscreen: true,
        pageWidth: window.screen.width - 40,
      });
    }
  };

  const {
    pageNumber,
    pageNumberFocus,
    pageNumberInput,
    numPages,
    pageWidth,
    fullscreen,
  } = state;

  return (
    <div className="pdf-view-wrapper">
      <div className="pdf-view">
        <div className="pdf-pageContainer">
          {pdfInfo?.pdfUrl && (
            <Document
              file={`/crm-venus/v1/venus/files/download/${pdfInfo.pdfUrl}.id`}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={<Spin className="spin-item" size="large" />}
            >
              <Page
                className="pdf-page"
                pageNumber={pageNumber}
                width={pageWidth}
                loading={<Spin className="spin-item" size="large" />}
                renderTextLayer={false}
              />
            </Document>
          )}
        </div>

        <div className="pdf-pageTool">
          <Tooltip title={pageNumber === 1 ? "已是第一页" : "上一页"}>
            <LeftOutlined onClick={lastPage} />
          </Tooltip>
          <Input
            value={pageNumberFocus ? pageNumberInput : pageNumber}
            onFocus={onPageNumberFocus}
            onBlur={onPageNumberBlur}
            onChange={onPageNumberChange}
            onPressEnter={toPage}
            type="number"
          />{" "}
          / {numPages}
          <Tooltip title={pageNumber === numPages ? "已是最后一页" : "下一页"}>
            <RightOutlined onClick={nextPage} />
          </Tooltip>
          <Tooltip title="放大">
            <PlusCircleOutlined onClick={pageZoomIn} />
          </Tooltip>
          <Tooltip title="缩小">
            <MinusCircleOutlined onClick={pageZoomOut} />
          </Tooltip>
          <Tooltip title={fullscreen ? "恢复默认" : "适合窗口"}>
            {fullscreen ? (
              <FullscreenExitOutlined onClick={pageFullscreen} />
            ) : (
              <FullscreenOutlined onClick={pageFullscreen} />
            )}
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Pdf;
